import { render, staticRenderFns } from "./NumberOrUnlimited.vue?vue&type=template&id=5d2f296c"
import script from "./NumberOrUnlimited.vue?vue&type=script&lang=js"
export * from "./NumberOrUnlimited.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports